/**
 * Normalise the UI path that rides on every frontend event (#389).
 *
 * This file imports NOTHING. `observability.ts` reaches `telemetry.ts`,
 * which uses `import.meta.env` — Vite syntax that a Playwright transform
 * cannot load — so a spec can import this one and not that one.
 */

/**
 * A UUID that forms a whole path segment.
 *
 * `/bouts/<uuid>` must group with every other bout. The raw pathname made
 * each id its own bucket, so the saved query `Frontend — which screen shows
 * errors (7d)` counted 21 screens of one visit each instead of one screen
 * with 21 — degraded for exactly the screens that matter most.
 */
const PATH_UUID = /\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?=\/|$)/gi;

/** Replace every id segment with `:id`, so the path names a SCREEN. */
export function normalisePath(pathname: string): string {
  return pathname.replace(PATH_UUID, '/:id');
}
